import { render, staticRenderFns } from "./create-new.vue?vue&type=template&id=39755629&"
import script from "./create-new.vue?vue&type=script&lang=js&"
export * from "./create-new.vue?vue&type=script&lang=js&"
import style0 from "./create-new.vue?vue&type=style&index=0&id=39755629&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports